import React from 'react';
import { Box } from '@fiverr-private/theme';

interface CounterBadgeProps {
    count: number;
}

export const CounterBadge = ({ count }: CounterBadgeProps) => (
    <Box
        as="span"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="16px"
        height="16px"
        borderRadius="circle"
        backgroundColor="grey_1200"
        color="grey_100"
        fontSize="b_xxs"
        fontWeight="bold"
        lineHeight="b_xxs"
        letterSpacing="0.5px"
    >
        {count}
    </Box>
);
